export const generateSetOfRandomNumbers = (count: number, seed: number) => {
  return Array.from({ length: count }, (_, k) => Math.abs(Math.sin(seed + k)))
}
